import { PageBracket } from "./page-bracket";
import { type PageSectionSharedProps, PageSectionView } from "./page-section";
import type { PageSection, SectionAvailability, SectionKey } from "./page-sections";

type PageSectionsListProps = PageSectionSharedProps & {
  /** The five sections of one visibility, in render order (`buildSections`). */
  sections: PageSection[];
  /** QL-205 — `sectionAvailability`: drop the parts of the structure the flow cannot use. */
  availability: SectionAvailability;
  hint: string;
};

/**
 * QL-117 — one visibility's pages as a single list in render order, with the repeated parts
 * drawn as brackets: the goal bracket holds the goal pages before the portfolios, the nested
 * portfolio bracket, and the goal pages after the portfolios. QL-205 — without a collection the
 * portfolio bracket is left out and the goal bracket collapses to one section.
 */
export function PageSectionsList({
  sections,
  availability,
  hint,
  ...shared
}: PageSectionsListProps) {
  const byKey = new Map(sections.map((s) => [s.key, s]));
  const view = (key: SectionKey) => {
    const section = byKey.get(key);
    return section ? <PageSectionView key={key} section={section} {...shared} /> : null;
  };

  return (
    <div className="space-y-6">
      {view("before_goals")}
      <PageBracket>
        {view("goal_before_portfolios")}
        {availability.showPortfolio && <PageBracket nested>{view("portfolio")}</PageBracket>}
        {availability.splitGoals && view("goal_after_portfolios")}
      </PageBracket>
      {view("after_goals")}
      <p className="text-xs text-muted-foreground">{hint}</p>
    </div>
  );
}
